import React, { useState, useCallback, memo } from "react";
import { useNavigate } from "react-router-dom";
import HotelActionsMenu from "../../Home/HotelActionsMenu";
import HotelPerformanceCell from "../../Home/HotelPerformanceCell";
import HotelStatusCell from "../../Home/HotelStatusCell";
import { formatLastCheck } from "../../Home/utils/homeUtils";

const HotelRow = ({ hotel, onUpdateStatus, onEditDescription, loadingStats }) => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuDirectionUp, setMenuDirectionUp] = useState(false);

  const hasLuniShower = Boolean(hotel.has_lunishower);

  const handleHotelClick = useCallback(() => {
    navigate(`/hotels/${hotel.id}?tab=lunishower`, { state: { hotel } });
  }, [navigate, hotel]);

  const handleMenuClick = useCallback((e) => {
    e.stopPropagation();

    // Récupérer la position du bouton "•••"
    const buttonRect = e.target.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const menuHeight = 200; // Estimation de la hauteur du menu

    // Si le menu dépasse en bas de la fenêtre, on l'affiche vers le haut
    const shouldShowUp = buttonRect.bottom + menuHeight > windowHeight;
    setMenuDirectionUp(shouldShowUp);

    // Ouvrir/fermer le menu
    setMenuOpen((open) => !open);
  }, []);

  const handleMenuClose = useCallback(() => setMenuOpen(false), []);

  return (
    <tr onClick={handleHotelClick} className="cursor-pointer hover:bg-gray-50 relative">
      <td className="px-3 py-3 text-sm font-medium text-gray-900 min-w-0">
        <div className="break-words max-w-full sm:max-w-xs md:max-w-sm lg:max-w-md" title={hotel.name}>
          {hotel.name}
        </div>
      </td>

      <td className="px-2 py-3 text-sm text-gray-500">{hasLuniShower ? <HotelPerformanceCell goodPercentages={hotel.good_percentages} loadingStats={loadingStats} /> : <span className="text-gray-400">—</span>}</td>

      <td className="px-2 py-3 text-sm text-gray-500">{hasLuniShower ? <HotelStatusCell roomStatus={hotel.room_status} loadingStats={loadingStats} /> : <span className="text-gray-400">—</span>}</td>

      <td className="px-2 py-3 text-sm text-gray-500">
        <div>{hotel.room_count ?? "—"}</div>
      </td>

      <td className="px-2 py-3 text-right relative" onClick={(e) => e.stopPropagation()}>
        {hasLuniShower && (
          <>
            <button onClick={handleMenuClick} className="text-gray-500 hover:text-gray-700 focus:outline-none">
              •••
            </button>
            <HotelActionsMenu hotel={hotel} hasLuniShower={hasLuniShower} hasGreenMiles={false} isOpen={menuOpen} onClose={handleMenuClose} showUp={menuDirectionUp} onUpdateStatus={onUpdateStatus} onEditDescription={onEditDescription} />
          </>
        )}
      </td>
    </tr>
  );
};

// Mémoïsé pour les mêmes raisons que `Home/HotelRow` : références d'hôtel préservées côté
// hook et handlers stables côté page suffisent à ne re-rendre que les lignes modifiées.
export default memo(HotelRow);
